import { combineReducers } from "redux";
import loginReducer from "./loginSlice";
import userReducer from "./userSlice";

const rootReducer = combineReducers({
	user: userReducer,
	login: loginReducer,
});

export default rootReducer;
